export const eventTitles = [
    "Euforia - El concert - Laura",
    "Kings League"
];

export const eventInformations = [
    {
        // Euforia - El concert - Laura
        allowed_referers: [],
        audio_imgs: [],
        audio_names: [],
        cam_imgs: [
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/euforia-elconcert-CAM1.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/euforia-elconcert-CAM2.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/euforia-elconcert-CAM3.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/euforia-elconcert-CAM4.jpg",
            "https://vz-827496d2-b59.b-cdn.net/52337566-c03f-44b3-b844-539930e64f04/preview.webp"
        ],
        cam_names: [
            "CAM1",
            "CAM2",
            "CAM3",
            "CAM4",
            "CAM5"
        ],
        captions_imgs: [],
        canBeIframe: true,
        product_id: "66f1ec3eeaf0932d440dcd5e",
        video_types: [
            "360",
            "360",
            "360",
            "360",
            "NONE"
        ],
        sources: [
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-euforia/h264_dash_hls/CAM1_mono_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-euforia/h264_dash_hls/CAM3_mono_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-euforia/h264_dash_hls/CAM4_mono_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-euforia/h264_dash_hls/CAM2_mono_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-euforia/h264_dash_hls/CAM0_mono_output/master.m3u8"
        ],
        // Se usará el valor recibido (por ejemplo, cii.contentId) en newRoom; aquí se coloca el valor actual.
        sources_dash: "https://d1ryvmmp9tg9ah.cloudfront.net/demo-euforia/h264_dash_hls/master8.mpd"
    },
    {
        // Kings League
        allowed_referers: [
            "www.intoreality.tv"
        ],
        audio_imgs: [
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/audio-ambient.png",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/audio-comentarista.png",
			"https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/audio-music.png"
        ],
        audio_names: [
            "AUDIO1",
            "AUDIO2"
        ],
        cam_imgs: [
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-banquillo1.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-bar.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-arbitro.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-mediocampo.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-porteria.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-corner.jpg",
            "https://dzsyhtfpcz9op.cloudfront.net/staticResources/camImages/kingsleague-ibai.jpg"
        ],
        cam_names: [
            "Banquillo Porcinos",
            "Bar Mahou",
            "Arbitro",
            "Medio campo",
            "Porteria",
            "Corner",
            "Twitch Ibai"
        ],
        captions_imgs: [],
        canBeIframe: true,
        product_id: "66f1ec3eeaf0932d440dcd5e",
        video_types: [
            "360",
            "360",
            "360",
            "360",
            "360",
            "360",
            "NONE"
        ],
        sources: [
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/TITAN02_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/PRO1_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/INSTA360SUBJETIVA_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/TITAN01_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/travesserX3_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/pro1terra_output/master.m3u8",
            "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/ibai_720p_output/master.m3u8"
        ],
        sources_dash: "https://d1ryvmmp9tg9ah.cloudfront.net/demo-kingsleague/h264_dash_hls/master1440.mpd"
    }
];